<template>
  <div id="current" class="col-lg-6">
    <div class="col-card mh">
      <h2>{{ $t('message.current') }}</h2>
      <div id="current-top" class="row">
        <div class="col-md-12">
          <div class="row">

            <template v-for="vitamin in vitamins">
              <div class="col-md-4 vitamin-col">
                <div class="score-wrapper">
                  <span v-if="vitamin.Title === 'Hinderpalen' || vitamin.Title === 'Ongezondheid'"
                        class="score score-three"
                        :class="'score-c-'+truncate(7-vitaminScore(vitamin)+1,0) + ' score-bc-'+truncate(7-vitaminScore(vitamin)+1,0)">
                    <span :class="((vitaminScore(vitamin)) % 1 > 0) ? 'small' : ''">
                      {{ vitaminScore(vitamin) }}
                    </span>
                  </span>
                  <span v-else
                        class="score score-three"
                        :class="'score-c-'+truncate(vitaminScore(vitamin),0) + ' score-bc-'+truncate(vitaminScore(vitamin),0)">
                    <span :class="(vitaminScore(vitamin) % 1 > 0) ? 'small' : ''">
                      {{ vitaminScore(vitamin) }}
                    </span>
                  </span>
                  <span class="score-label">
                  {{ localizedField(vitamin, 'Title') }}
                </span>
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>
      <div id="current-bottom" class="row">
        <div v-if="current" id="current-val" class="border-grey-after"
             :class="user.teams.length ? 'col-md-4 col-xxl-4' : 'col-md-6 col-xxl-6'">
          <div class="label-centered">
            {{ $t('message.vip') }}
          </div>
          <div class="score-big score-big-three"
               :class="'score-c-'+truncate(current.vipscore,0) + ' score-bc-'+truncate(current.vipscore,0)">
            <div class="content">
              {{ truncate(current.vipscore, 1) }}
            </div>
          </div>
        </div>

        <div id="current-avg" class="flex-column col-md-4 col-xxl-4 border-grey-after" v-if="user.teams.length">

          <div class="team-slider-title">
            <template v-for="(team,teamindex) in user.teams">
              <div v-if="teamindex===activeTeam"
                   class="label-centered d-flex justify-content-between align-items-center">
                <button v-if="user.teams.length > 1" @click.prevent="changeSlide('prev')"
                        class="text-muted p-0 btn btn-link btn-sm">
                  <i class="fas fa-caret-left"></i>
                </button>
                <!--                <span class="flex-grow-1 d-block text-center">{{ truncate(team.Title,13,'string') }}</span>-->
                <span class="flex-grow-1 d-block text-center">{{ team.Title }}</span>
                <button v-if="user.teams.length > 1" @click.prevent="changeSlide('next')"
                        class="text-muted p-0 btn btn-link btn-sm">
                  <i class="fas fa-caret-right"></i>
                </button>
              </div>
            </template>

          </div>
          <div class="flex-grow-1 flex-shrink-0 team-slider position-relative overflow-hidden">
            <transition name="teamslider" mode="out-in">
              <div v-for="(team,teamindex) in user.teams" v-if="teamindex===activeTeam" class="team-slide  mw-100">
                <div class="score-big score-big-three"
                     :class="'score-c-'+truncate(team.vipscore,0) + ' score-bc-'+truncate(team.vipscore,0)">
                  <div class="content">
                    {{ truncate(team.vipscore, 1) }}
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div v-if="user.teams.length > 1" class="team-slider-pager text-center mt-1">
            <template v-for="(team,i) in user.teams">
              <button :class="activeTeam === i ? 'score-c-4' : 'text-muted'"
                      @click="activeTeam = i"
                      class="btn-link btn small btn-sm indicator pl-1 pr-1">
                <i class="fa-xs fas fa-circle"></i>
              </button>
            </template>
          </div>

          <!--          <template v-else>-->
          <!--            <div class="team-slider-title">-->
          <!--                <div-->
          <!--                     class="label-centered d-flex justify-content-between align-items-center">-->
          <!--                  <span class="flex-grow-1 d-block text-center">{{$t('message.no_team')}}</span>-->
          <!--                </div>-->
          <!--            </div>-->
          <!--            <div class="score-big score-big-three">-->
          <!--              <div class="content">-->
          <!--                &#45;&#45;-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </template>-->


        </div>

        <div class="" :class="user.teams.length ? 'col-md-4 col-xxl-4' : 'col-md-6 col-xxl-6'">
          <div class="label-centered">
            {{ companyName }}
          </div>
          <div class="score-big score-big-three"
               v-if="company"
               :class="'score-c-'+truncate(company.vipscore,0) + ' score-bc-'+truncate(company.vipscore,0)">
            <div class="content">
              {{ truncate(company.vipscore, 1) }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import store from "../../store/store";

export default {
  methods: {
    changeSlide(dir = 'next') {
      let last_index = (this.user.teams.length) - 1;
      let active_index = this.activeTeam;

      let next_index = active_index + 1;
      if (next_index > last_index) {
        next_index = 0
      }
      let prev_index = active_index - 1;
      if (prev_index < 0) {
        prev_index = last_index
      }

      if (dir === 'next') {
        this.activeTeam = next_index
      }
      if (dir === 'prev') {
        this.activeTeam = prev_index
      }
    },
    // getTeamAvg() {
    //   if (this.user.teams[0]) {
    //     this.axios.get('/averages?type=team&team=' + this.user.teams[0].id + '&_sort=date:DESC&_limit=1').then(tags => tags.data)
    //       .then(res => {
    //         const data = res[0];
    //         this.teamAvg = data;
    //       });
    //   }
    // },
    vitaminScore(vitamin, type = 'average') {
      let score = 0;
      if (this.current.data) {
        const vitaminScores = this.current.data.children;
        for (let key in vitaminScores) {
          if (vitaminScores[key].id === vitamin.id) {
            score = vitaminScores[key][type]
          }
        }
      }

      return this.truncate(score, 1);
    },

  },
  computed: {
    companyName() {
      return this.company.Title
    }
  },
  data() {
    return {
      activeTeam: 0,
      company: store.getters.getCompany,
      user: store.getters.getUser,
      teamAvg: {average: 0},
    }
  },

  created() {
    //   console.log('this user', this.user)
    this.user = store.getters.getUser;
    this.company = store.getters.getCompany;

    // this.getTeamAvg()

    // this.getCompanyAvg()


  },
  props: {
    current: {
      type: Object,
      default() {
        return {average: 0}
      }
    },
    vitamins: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style>

.teamslider-enter-active, .teamslider-leave-active {
  transition: opacity .4s;
}

.teamslider-enter, .teamslider-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

/*.teamslider-leave-to {*/
/*  !*transform: translateX(-100%);*!*/
/*  opacity:0*/
/*}*/

/*.teamslider-enter {*/
/*  !*transform: translateX(100%);*!*/
/*  opacity:0*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Current.vue